import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { consumeRedirectPath } from '../components/Auth/RequireAuth'

export default function PublicLayout() {
    const { demoModeEnabled, login, isAuthenticated, loading } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        if (!loading && isAuthenticated) {
            // Send the user where they were originally headed (M14 deep links);
            // falls back to the shelter hub when no destination was stored.
            navigate(consumeRedirectPath() || '/shelter')
        }
    }, [isAuthenticated, loading, navigate])

    if (loading) {
        return (
            <div className="min-h-screen bg-bg-darkest flex items-center justify-center">
                <div className="animate-pulse text-accent-blue font-bold tracking-widest uppercase">
                    Loading...
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-bg-darkest font-sans text-text-main">
            <header className="relative bg-gradient-to-b from-bg-darkest via-bg-darker to-bg-darkest border-b-2 border-border-light shadow-[0_4px_12px_rgba(0,0,0,0.5)]">
                <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-accent-blue/50 to-transparent"></div>
                <div className="max-w-[1600px] mx-auto px-4 py-6 text-center">
                    <div className="flex items-center justify-center gap-3 mb-2">
                        <div className="relative">
                            <div className="w-12 h-12 bg-gradient-to-br from-accent-blue/20 to-accent-blue/5 border-2 border-accent-blue/30 rounded-lg flex items-center justify-center backdrop-blur-sm">
                                <span className="text-2xl">⚡</span>
                            </div>
                            <div className="absolute -top-1 -right-1 w-3 h-3 bg-accent-red rounded-full border-2 border-bg-darkest animate-pulse"></div>
                        </div>
                        <div>
                            <h1 className="text-3xl md:text-4xl font-bold text-white tracking-tight leading-tight">
                                <span className="bg-gradient-to-r from-white via-text-lighter to-accent-blue bg-clip-text text-transparent">
                                    Commonfolk Downfall
                                </span>
                            </h1>
                            <p className="text-sm md:text-base text-text-muted font-medium tracking-wide uppercase mt-1">
                                Idle Extraction Simulator
                            </p>
                        </div>
                    </div>
                </div>
            </header>

            <Outlet />
        </div>
    )
}
